import { PlotCreator } from "../core/view-object-creators/plot-creator";
import { OfflineDataPlot } from "../../../../web-visualizator";

export class OfflinePlotCreator extends PlotCreator {
  constructor(commonSettings) {
    super(commonSettings);
  }

  createPlotObject(settings) {
    return new OfflineDataPlot(settings);
  }
}
